import { render, staticRenderFns } from "./NewFooter.vue?vue&type=template&id=231532d8&scoped=true"
import script from "./NewFooter.vue?vue&type=script&lang=js"
export * from "./NewFooter.vue?vue&type=script&lang=js"
import style0 from "./NewFooter.vue?vue&type=style&index=0&id=231532d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231532d8",
  null
  
)

export default component.exports